import { toast } from 'react-toastify';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import {
  COLLECTIONS_CREATE_COLLECTION_SNAPSHOT_BEGIN,
  COLLECTIONS_CREATE_COLLECTION_SNAPSHOT_SUCCESS,
  COLLECTIONS_CREATE_COLLECTION_SNAPSHOT_FAILURE,
  COLLECTIONS_CREATE_COLLECTION_SNAPSHOT_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function createCollectionSnapshot(args = {}) {
  return (dispatch) => {
    dispatch({
      type: COLLECTIONS_CREATE_COLLECTION_SNAPSHOT_BEGIN,
    });
    const { projectId, version, data } = args;
    const header = builderSurfaceJsonContentHeader(projectId);

    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/collection-snapshots`,
        data,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: COLLECTIONS_CREATE_COLLECTION_SNAPSHOT_SUCCESS,
            data: res,
          });
          toast.success('Collection Snapshot Created Successfully !');

          resolve(res);
        },
        (err) => {
          dispatch({
            type: COLLECTIONS_CREATE_COLLECTION_SNAPSHOT_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err);
          toast.error(`Failed: ${errMsg}` || 'Creation Failed !');
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissCreateCollectionSnapshotError() {
  return {
    type: COLLECTIONS_CREATE_COLLECTION_SNAPSHOT_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COLLECTIONS_CREATE_COLLECTION_SNAPSHOT_BEGIN:
      return {
        ...state,
        createCollectionSnapshotPending: true,
        createCollectionSnapshotError: null,
      };

    case COLLECTIONS_CREATE_COLLECTION_SNAPSHOT_SUCCESS:
      // The request is success
      return {
        ...state,
        createCollectionSnapshotPending: false,
        createCollectionSnapshotError: null,
      };

    case COLLECTIONS_CREATE_COLLECTION_SNAPSHOT_FAILURE:
      // The request is failed
      return {
        ...state,
        createCollectionSnapshotPending: false,
        createCollectionSnapshotError: action.data.error,
      };

    case COLLECTIONS_CREATE_COLLECTION_SNAPSHOT_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        createCollectionSnapshotError: null,
      };

    default:
      return state;
  }
}
